// extracted by mini-css-extract-plugin
module.exports = {"no_pick":"NoPick_no_pick__TJhOA"};